// extracted by mini-css-extract-plugin
module.exports = {"decor":"styles_decor__E4ek8","icon":"styles_icon__f7H5n"};